var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 25.5625C9.5625 27.6458 12.0833 28.6875 15 28.6875C17.9167 28.6875 20.4167 27.6458 22.5 25.5625C24.625 23.4375 25.6875 20.9167 25.6875 18C25.6875 15.0833 24.625 12.5833 22.5 10.5C20.4167 8.375 17.9167 7.3125 15 7.3125C12.0833 7.3125 9.5625 8.375 7.4375 10.5C5.35417 12.5833 4.3125 15.0833 4.3125 18C4.3125 20.9167 5.35417 23.4375 7.4375 25.5625ZM5.5625 8.625C8.1875 6 11.3333 4.6875 15 4.6875C18.6667 4.6875 21.7917 6 24.375 8.625C27 11.2083 28.3125 14.3333 28.3125 18C28.3125 21.6667 27 24.8125 24.375 27.4375C21.7917 30.0208 18.6667 31.3125 15 31.3125C11.3333 31.3125 8.1875 30.0208 5.5625 27.4375C2.97917 24.8125 1.6875 21.6667 1.6875 18C1.6875 14.3333 2.97917 11.2083 5.5625 8.625Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.cb884691648855cdd966e5b8485cfb91.svg";
export { ForwardRef as ReactComponent };